import React from 'react';
import { Card, Tabs, Typography } from 'antd';
import CompanyListTable from './CompanyListTable';
import { CheckCircleOutlined, ClockCircleOutlined, ExclamationCircleOutlined, ExperimentOutlined } from '@ant-design/icons';
import { CompanyInBreakdown } from '../../../../types/super-admin.types';

const { TabPane } = Tabs;
const { Title } = Typography;

interface CompanyStatusTabsProps {
  activeCompanies: CompanyInBreakdown[];
  trialCompanies: CompanyInBreakdown[];
  gracePeriodCompanies: CompanyInBreakdown[];
  expiredCompanies: CompanyInBreakdown[];
  loading: boolean;
}

const CompanyStatusTabs: React.FC<CompanyStatusTabsProps> = ({
  activeCompanies,
  trialCompanies,
  gracePeriodCompanies,
  expiredCompanies,
  loading,
}) => {
  return (
    <Card className="border-0 shadow-sm" bodyStyle={{ paddingTop: '0' }}>
      <Tabs defaultActiveKey="1" type="card" size="large">
        <TabPane
          tab={
            <span>
              <CheckCircleOutlined /> Aktif Şirketler ({activeCompanies.length})
            </span>
          }
          key="1"
        >
          <CompanyListTable companies={activeCompanies} loading={loading} title="" />
        </TabPane>
        <TabPane
          tab={
            <span>
              <ExperimentOutlined /> Deneme Sürümünde ({trialCompanies.length})
            </span>
          }
          key="2"
        >
          <CompanyListTable companies={trialCompanies} loading={loading} title="" />
        </TabPane>
        <TabPane
          tab={
            <span>
              <ExclamationCircleOutlined /> Tolerans Süresinde ({gracePeriodCompanies.length})
            </span>
          }
          key="3"
        >
          <CompanyListTable companies={gracePeriodCompanies} loading={loading} title="" />
        </TabPane>
        <TabPane
          tab={
            <span>
              <ClockCircleOutlined /> Süresi Dolmuş ({expiredCompanies.length})
            </span>
          }
          key="4"
        >
          <CompanyListTable companies={expiredCompanies} loading={loading} title="" />
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default CompanyStatusTabs; 